import { render, staticRenderFns } from "./ActivateList.vue?vue&type=template&id=08a2d07b"
import script from "./ActivateList.vue?vue&type=script&lang=js"
export * from "./ActivateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports